import { createAction, props } from '@ngrx/store';
import { SortDirection } from '@shared/enums';
import { ReportDownloadInProgress } from '@shared/models/dpr';

export const toggleSidebar = createAction('[App] Toggle Sidebar');

export const toggleFullScreenMode = createAction('[App] Toggle Full Screen');

export const setAppOnlineStatus = createAction(
  '[App] Set App Online Status',
  props<{ appOnline: boolean }>()
);

export const setLoginPageDisplayed = createAction(
  '[App] Set Login Page Displayed',
  props<{ loginPageDisplayed: boolean }>()
);

export const setRedirectedToCore = createAction(
  '[App] Set Redirected To Core',
  props<{ redirectedToCore: boolean }>()
);

export const showLoader = createAction('[App] Show Loader');

export const hideLoader = createAction('[App] Hide Loader');

export const setAppLockedInOffline = createAction(
  '[App] Set App Locked In Offline',
  props<{ appLockedInOffline: boolean }>()
);

export const setDprsSortingDirection = createAction(
  '[App] Set Dprs Sorting Direction',
  props<{ sortingDirection: SortDirection }>()
);

export const setReportDownload = createAction(
  '[App] Set Report Download',
  props<{ reportDownload: ReportDownloadInProgress }>()
);

export const clearReportDownload = createAction(
  '[App] Clear Report Download',
  props<{ dprDetailId: number }>()
);

export const clearAppState = createAction('[App] Clear State');
